import React from 'react';
import PageLayout from '../components/PageLayout';

/**
 * Contact Us page component
 */
const ContactPage: React.FC = () => {
  return (
    <PageLayout 
      title="Contact Us" 
      subtitle="We're here to help with your questions and feedback"
      backgroundImage="https://images.pexels.com/photos/6573472/pexels-photo-6573472.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <div className="two-column-content">
        <div>
          <section>
            <h2>Get in Touch</h2>
            <p>
              Whether you have questions about booking a tee time, want to suggest a feature, or are interested 
              in partnering with us, we'd love to hear from you. Our team is dedicated to providing excellent 
              service and support to our golfing community.
            </p>
            
            <div className="content-card">
              <h3>Contact Information</h3>
              <p><strong>Email:</strong> support@golfscape.com</p>
              <p><strong>Phone:</strong> (555) 123-4567</p>
              <p><strong>Hours:</strong> Monday - Friday: 8am - 8pm ET<br />Saturday - Sunday: 9am - 5pm ET</p>
              
              <h3>Headquarters</h3>
              <p>
                GolfScape, Inc.<br />
                123 Fairway Drive<br />
                Suite 200<br />
                Scottsdale, AZ 85255
              </p>
            </div>
          </section>
        </div>
        
        <div>
          <section>
            <h2>Send Us a Message</h2>
            <form className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input type="text" id="name" placeholder="John Smith" />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" placeholder="your.email@example.com" />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <select id="subject">
                  <option value="">Please select a subject</option>
                  <option value="booking">Booking Assistance</option>
                  <option value="technical">Technical Support</option>
                  <option value="partnership">Partnership Inquiry</option>
                  <option value="feedback">Feedback</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Your Message</label>
                <textarea id="message" rows={6} placeholder="How can we help you?"></textarea>
              </div>
              
              <button type="submit" className="form-submit">Send Message</button>
            </form>
          </section>
        </div>
      </div>
      
      <section>
        <h2>Frequently Asked Questions</h2>
        <div className="two-column-content">
          <div className="content-card">
            <h3>Booking Questions</h3>
            <p><strong>How far in advance can I book a tee time?</strong></p>
            <p>Most courses allow bookings up to 14 days in advance, though some premium courses may offer longer booking windows.</p>
            
            <p><strong>Can I cancel or modify my booking?</strong></p>
            <p>Yes, you can manage your bookings through your account. Please note that cancellation policies vary by course.</p>
          </div>
          
          <div className="content-card">
            <h3>Account Questions</h3>
            <p><strong>How do I create an account?</strong></p>
            <p>Click on "Sign Up" in the top right corner of the homepage. You'll need to provide your name, email, and create a password.</p>
            
            <p><strong>Is my payment information secure?</strong></p>
            <p>Absolutely. We use industry-standard encryption and never store your full credit card details on our servers.</p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default ContactPage;
